exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-icon[data-v-29241a4d] {\n  background: #0bda8e !important;\n}\n[data-v-29241a4d] .form-wrapper {\n  width: 100% !important;\n}\n.custom-toolbar-template-name[data-v-29241a4d] {\n  margin-top: 10px;\n}\n.custom-back-button[data-v-29241a4d] {\n  margin-bottom: 10px;\n  margin-right: 10px;\n  color: #333333 !important;\n}\n", ""]);

// exports
